module.exports = __webpack_public_path__ + "img/3.6cc54b2d.jpg";